import Vue from 'vue'
import { MutationTree } from 'vuex'
import { ScriptEditState } from './state'
import {
  ScriptCardResponse,
  CardBlock,
  TCardBlockValue,
  CardOption,
} from '@/models/scripts'
import { CardVariant } from '@/constants/scripts'

export enum ScriptEditMutationTypes {
  Edit = '[Scripts Edit Mutation] Edit',
  SetCard = '[Scripts Edit Mutation] Set Card',
  SetVariant = '[Scripts Edit Mutation] Set Variant',
  SetBlocks = '[Scripts Edit Mutation] Set Blocks',
  SetBlockValue = '[Scripts Edit Mutation] Set Block Value',
  SetOptions = '[Scripts Edit Mutation] Set Options',
}

export type ScriptEditMutationPayload = {
  cardId: string
  scriptId: string
  instanceId: string
  variant?: CardVariant
}

export type ScriptEditSetCardMutationPayload = {
  card: ScriptCardResponse
}

export type ScriptEditSetBlocksMutationPayload = {
  blocks: CardBlock[]
  cardId: string
  variant?: CardVariant
}

export type ScriptEditSetBlockValueMutationPayload = {
  value: TCardBlockValue
  cardId: string
  variant?: CardVariant
  blockId: string
}

export type ScriptEditSetOptionsMutationPayload = {
  options: CardOption[]
  cardId: string
  variant?: CardVariant
}

export const mutations: MutationTree<ScriptEditState> = {
  [ScriptEditMutationTypes.Edit](state, payload: ScriptEditMutationPayload) {
    const { cardId, scriptId, instanceId, variant = CardVariant.A } = payload

    state.cardId = cardId
    state.scriptId = scriptId
    state.scriptId = scriptId
    state.instanceId = instanceId
    state.variant = variant
  },

  [ScriptEditMutationTypes.SetCard](
    state,
    payload: ScriptEditSetCardMutationPayload,
  ) {
    const { card } = payload

    Vue.set(state.cards, card.id, card)
  },

  [ScriptEditMutationTypes.SetVariant](state, payload: CardVariant) {
    state.variant = payload
  },

  [ScriptEditMutationTypes.SetBlocks](
    state,
    payload: ScriptEditSetBlocksMutationPayload,
  ) {
    const { blocks, cardId, variant = CardVariant.A } = payload
    const content = state.cards[cardId]?.content[variant]
    if (content) {
      content.blocks = blocks
    }
  },

  [ScriptEditMutationTypes.SetBlockValue](
    state,
    payload: ScriptEditSetBlockValueMutationPayload,
  ) {
    const { value, cardId, blockId, variant = CardVariant.A } = payload
    const blocks = state.cards[cardId]?.content[variant]?.blocks
    if (blocks) {
      const blockIndex = blocks.findIndex(b => b.id === blockId)
      if (blockIndex >= 0) {
        blocks[blockIndex].d = value
      }
    }
  },

  [ScriptEditMutationTypes.SetOptions](
    state,
    payload: ScriptEditSetOptionsMutationPayload,
  ) {
    const { options, cardId, variant = CardVariant.A } = payload
    const content = state.cards[cardId]?.content[variant]
    if (content) {
      content.options = options
    }
  },
}
